import FieldDefs from './SitePagesFieldDefs'
import SitePagesGny from './SitePagesGny'
import {doLangFields, isGoogleGny} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.sitepages", isGoogleGny() ? SitePagesGny : FieldDefs),
            sortOrder: [
                {
                    field: 'it50',
                    direction: 'desc'
                }
            ],
            moreParams: {}
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
